import { X } from "lucide-react";
import { Button } from "../components/ui/button";
import useSWRMutation from "swr/mutation";
import { handleMutation } from "../util/axiosConfig";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import { Input } from "../components/ui/input";
import { ChangeEvent, FormEvent, useState } from "react";
import requestErrorHandler from "../util/requestErrorHandler";
import { message } from "antd";
import { Textarea } from "../components/ui/textarea";


interface CreatePartnerProp {
  onClose: () => void
  onSubmit: () => void
}

function CreatePartner({ onClose, onSubmit }: CreatePartnerProp) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    limit: ''
  })
  const { trigger: triggerCreatePartner, isMutating: isCreating } = useSWRMutation("newPartner/create", handleMutation);

  const handleInputChange  = (event: ChangeEvent<HTMLInputElement>) => {
    setFormData({
    ...formData,
    [event.target.name]: event.target.value
    })
  }

  const handleTextAreaChange  = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    })
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    try {
        e.preventDefault();

        await triggerCreatePartner({
          email: formData.email,
          businessAddress: formData.address,
          businessName: formData.name,
          limit: formData.limit
        });

        message.success("Partner created Successfully!");
        setFormData({
          name: '',
          email: '',
          address: '',
          limit: ''
        });
        onSubmit();
    } catch (error) {
        requestErrorHandler(error);
    }
  }

  return (
    <div className="bg-white rounded-lg shadow p-6 transition-all duration-300">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-blue-600">Create Partner</h2>
        <Button variant="ghost" size="icon" onClick={onClose} className="hover:bg-gray-100">
          <X className="h-5 w-5 text-red-500" />
        </Button>
      </div>

      <form className="space-y-4" onSubmit={handleSubmit}>
        <div className="space-y-2">
            <label htmlFor="name" className="text-gray-700 font-medium">
              Business Name
            </label>
            <Input
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="bg-gray-200 border-l-4 border-blue-600"
                required
            />
        </div>
        <div className="space-y-2">
            <label htmlFor="email" className="text-gray-700 font-medium">
                Business Email Address
            </label>
            <Input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="bg-gray-200 border-l-4 border-blue-600"
                required
            />
        </div>    
        <div className="space-y-2">
          <label htmlFor="address" className="text-gray-700 font-medium">
            Business Address
          </label>
          <Textarea
              id="address"
              name="address"
              role="5"
              value={formData.address}
              onChange={handleTextAreaChange}
              className="bg-gray-200 border-l-4 border-blue-600"
              required
          ></Textarea>
        </div>
        <div className="space-y-2">
          <label htmlFor="limit" className="text-gray-700 font-medium">
            Limit
          </label>
          {formData.limit}
          <Input
            id="limit"
            type="number"
            name="limit"
            value={formData.limit}
            onChange={handleInputChange}
            className="bg-gray-200 border-l-4 border-blue-600"
            required
          />
        </div>
        <div>
          <Button
              type="submit"
              className="text-white w-full mt-4"
              disabled={isCreating}
          >
            Create {isCreating && <LoadingSpinner />}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default CreatePartner;